import React, { useEffect } from "react";
import { connect } from "react-redux";
import { handleSocialLoginCallback } from "../../services/user/actions";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function SocialLoginCallback(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const error = params.get("error");
  const { t } = useTranslation();

  useEffect(() => {
    if (token) {
      props
        .handleSocialLoginCallback(token)
        .then((user) => {
          if (user?.auth_token) {
            enqueueSnackbar("Login successful!", { variant: "success" });
            window.location.href = "/dashboard";
          } else {
            let errorMessage = "Login failed. Please try again.";
            if (error === "UserNotFound") {
              errorMessage = "User not found. Please register first on KPG.";
            } else if (error === "AffiliateNotActive") {
              errorMessage =
                "Your affiliate account is not active. Please contact support.";
            } else if (error === "AuthFailed") {
              errorMessage = "Authentication failed. Please try again.";
            }
            enqueueSnackbar(`${errorMessage} | ${error}`, { variant: "error" });
            navigate("/login");
          }
        })
        .catch(() => {
          enqueueSnackbar("Login failed. Please try again.", {
            variant: "error",
          });
          navigate("/login");
        });
    } else {
      let errorMessage = "Login failed. Please try again.";
      if (error === "UserNotFound") {
        errorMessage = "User not found. Please register first on KPG.";
      } else if (error === "AffiliateNotActive") {
        errorMessage =
          "Your affiliate account is not active. Please contact support.";
      } else if (error === "AuthFailed") {
        errorMessage = "Authentication failed. Please try again.";
      }
      enqueueSnackbar(`${errorMessage}. Err: ${error}`, { variant: "error" });
      navigate("/login");
    }
  }, [token, error]);

  return (
    <Box className="social-login-wrapper">
      <img
        src="/images/kpg-logo.png"
        alt="Logo"
        className="social-login-logo"
      />
      <CircularProgress size={60} className="circular-progress" />
      <Typography variant="h6" className="social-login-text">
        {t("common_please_wait")}
      </Typography>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = {
  handleSocialLoginCallback,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialLoginCallback);
